const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogEventoCalendario(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogEventoCalendario`, params);
    },
    $obterRelatorioLogCSVEventoCalendario(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogEventoCalendarioCsv`, params);
    },
    $obterRelatorioLogPDFEventoCalendario(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogEventoCalendarioPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
